import ls from 'local-storage'

export default {

  // TODO disable in production

  get () {
    let logger = ls.get('logger')
    return logger || {}
  },

  log (key, object) {
    console.log(key, object)
    let logger = this.get()
    logger[key] = object
    ls.set('logger', logger)
  },

  reset () {
    ls.remove('logger')
  }

}



// WEBPACK FOOTER //
// ./src/modules/Logger.js